import React, { useState, useEffect } from "react";
import { VscClose } from "react-icons/vsc";
import { CgMenuRight } from "react-icons/cg";
import { motion } from "framer-motion";
import { scrollToTop, scrollToSection, } from "../utils/lenisScroll";

const Header = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [activeSection, setActiveSection] = useState("");

  const toggleMenu = () => {
    setShowMenu((prev) => !prev);
  };

  const handleScroll = () => {
    const sections = document.querySelectorAll("section");
    let currentSection = "";

    sections.forEach((section) => {
      const sectionTop = section.offsetTop - 300;
      if (window.scrollY >= sectionTop) {
        currentSection = section.getAttribute("id");
      }
    });

    setActiveSection(currentSection);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const variants = {
    open: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0,
        type: "spring",
        damping: 25,
        stiffness: 500,
      },
    },
    closed: {
      opacity: 0.2,
      x: "-100%",
      transition: {
        delay: 0,
        duration: 0,
      },
    },
  };

  return (
    <header className="header fixed lg:fixed w-full bg-[#113023] z-10">
      <nav className="nav xl:max-w-[90rem] xl:mx-auto">
        <div className="header-wrapper px-6 lg:px-16 h-[4rem] lg:mb-[0] flex justify-between items-center lg:grid grid-cols-2">
          <div className="page-header inline-flex">
            <button
              onClick={scrollToTop}
              aria-label="Scroll to top"
              className="nav-links"
            >
              <h1 className="page-header-title nav-link">
                Emuobonuvie Pleasure
              </h1>
            </button>
          </div>
          <motion.div
            whileTap={{ scale: 1.2, opacity: 0, animationDelay: 5 }}
            className="hamburger-menu-btn flex justify-self-end lg:hidden"
          >
            {showMenu ? (
              <motion.button onClick={toggleMenu}>
                <VscClose size="2rem" className="mr-[-0.4rem] menu-close" />
              </motion.button>
            ) : (
              <motion.button onClick={toggleMenu}>
                <CgMenuRight
                  size="2rem"
                  className="mr-[-0.2rem] menu-open"
                  aria-label="menu-open"
                />
              </motion.button>
            )}
          </motion.div>
          <div className="nav hidden lg:grid justify-self-start ml-[1rem]">
            <ul className="nav-links flex lg:gap-[4rem] nav-item">
              {["about", "work", "contact"].map((section) => (
                <li key={section} className="nav-link hover:transform transition duration-300 hover:scale-110">
                  <button
                    onClick={() => {
                      scrollToSection(section);
                      setShowMenu(false);
                    }}
                    className={`nav-link m-link ${activeSection === section ? "active-link" : ""
                      }`}
                  >
                    {section.charAt(0).toUpperCase() + section.slice(1)}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Mobile Nav */}
        <motion.div
          initial={{ opacity: 0.5, x: "-100%" }}
          animate={showMenu ? "open" : ""}
          variants={variants}
          transition={{ duration: 0.5 }}
          onClick={() => setShowMenu(false)}
          className="hamburger-menu-open nav-list fixed h-dvh top-[4rem] right-0 bottom-0 w-full bg-[rgba(17,48,35,0.80)] overflow-hidden flex flex-col items-center justify-around"
        >
          {["about", "work", "contact"].map((section) => (
            <button
              key={section}
              onClick={() => {
                scrollToSection(section);
                setShowMenu(false);
              }}
              className={`hamburger-link px-6 text-[1.5rem] border-t-[1px] border-b-[#e5e5e5] w-full flex flex-col justify-center items-start basis-[33.3%] ${activeSection === section
                ? "mobile-active-link"
                : ""
                }`}
            >
              {section.toUpperCase()}
            </button>
          ))}
        </motion.div>
      </nav>
    </header>
  );
};

export default Header;
